export default __webpack_public_path__ + "static/media/institucion.8be7e614.jpeg";